import React, { useEffect, useRef, useState } from 'react';

import getSellerOtherItems from '../../../repositories/getSellerOtherItems';

import { TListingClient } from 'types/TListing';
import { TSellerOtherItem } from 'types/TSellerOtherItem';

type TSellerOtherItemsProps = {
  listing: TListingClient;
};

let SellerOtherItemCarousel;

const SellerOtherItemsLazy = ({ listing }: TSellerOtherItemsProps) => {
  const sellerOtherItemsRef = useRef<HTMLDivElement | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState<TSellerOtherItem[]>([]);
  const [itemsCount, setItemsCount] = useState(0);
  const {
    itemId,
    seller: { id: sellerId },
    category,
  } = listing;

  useEffect(() => {
    const elementRef = sellerOtherItemsRef.current as Element;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.disconnect();
            (async () => {
              try {
                const [sellerOtherItemsData, SellerOtherItemCarouselChunk] = await Promise.all([
                  getSellerOtherItems({ sellerId, itemId, categoryId: category.id }),
                  import(/* webpackChunkName: "SellerOtherItemCarousel" */ './SellerOtherItemCarousel'),
                ]);

                if (sellerOtherItemsData.items.length) {
                  setItems(sellerOtherItemsData.items);
                  setItemsCount(sellerOtherItemsData.total);
                  SellerOtherItemCarousel = SellerOtherItemCarouselChunk.default;
                  setIsLoaded(true);
                }
              } catch {}
            })();
          }
        });
      },
      {
        rootMargin: '0px 0px 400px 0px',
      },
    );

    if (elementRef) {
      observer.observe(elementRef);
    }

    return () => {
      if (elementRef) {
        observer.disconnect();
      }
    };
  }, [category, itemId, sellerId]);

  return (
    <div className="SellerOtherItemsContainer hz-Page-section hz-Page-section--separated" ref={sellerOtherItemsRef}>
      {isLoaded && <SellerOtherItemCarousel listing={listing} sellerOtherItems={items} totalItemsCount={itemsCount} />}
    </div>
  );
};

export default SellerOtherItemsLazy;
